<template>

    <div v-if="global.candidate!=null" class="q-pa-md">

        <div class="q-gutter-y-md">
            <q-card>
                <q-tabs v-model="tab" dense class="text-grey" active-color="red" indicator-color="red" align="justify"
                    narrow-indicator>
                    <q-tab name="details" icon="info" label="details" active></q-tab>
                    <q-tab name="funding" icon="paid" label="Funding">
                        <q-badge v-if="global.candidate.Donors.length>0" color="red" text-color="white" align="top">
                            {{global.candidate.Donors.length}}
                        </q-badge>
                    </q-tab>
                    <q-tab name="voting" icon="receipt_long" label="voting">
                        <q-badge v-if="global.candidate.voted" color="red">
                            <q-icon name="done" color="white" />
                        </q-badge>
                    </q-tab>
                </q-tabs>

                <q-separator />

                <q-tab-panels v-model="tab" animated>

                    <q-tab-panel name="details">
                        <Details />
                    </q-tab-panel>

                    <q-tab-panel name="funding">
                        <Funding />

                    </q-tab-panel>

                    <q-tab-panel name="voting">
                        <Voting />
                    </q-tab-panel>

                </q-tab-panels>

            </q-card>

        </div>

    </div>

</template>


<style>
</style>

<script>

    import { global } from './Global.js';

    import Details from './Details.vue'
    import Funding from './Funding.vue';
    import Voting from './Voting.vue'

    export default {
        name: 'Tabs',

        components: {
            Details,
            Funding,
            Voting
        },

        data() {
            return {
                tab: "details",
                selected: global.selected,

                global

            }

        }
    }
</script>